import { AccountCircle } from '@mui/icons-material';
import { InputAdornment } from '@mui/material';
import { FC, forwardRef } from 'react';

import { IField } from '../form-element.inrerface';

import styles from './CheckoutField.module.sass';
import { CheckoutFieldCss } from './CheckoutFieldCss';

const CheckoutField = forwardRef<HTMLInputElement, IField>(
  ({ label, error, ...rest }, ref) => {
    return (
      <div className={styles.wrapper}>
        <CheckoutFieldCss
          ref={ref}
          {...rest}
          id="standard-basic"
          variant="outlined"
          label={label}
          type="text"
          size="small"
          color="info"
          fullWidth
        />
        {error && <div className={styles.error}>{error.message}</div>}
      </div>
    );
  }
);

CheckoutField.displayName = 'CheckoutField';

export default CheckoutField;
